export default ({ $config }) => {
  return {
    httpEndpoint: $config.apollo.httpEndpoint,

    browserHttpEndpoint: $config.apollo.browserHttpEndpoint,
  }
}
